// extracted by mini-css-extract-plugin
module.exports = {"title":"-dFXev","text":"_1gPE4f"};